module.exports = __webpack_public_path__ + "static/media/Lunala_gaussian2.74f78086.png";